<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    // this.updateTitle(); // 确保在组件加载后立即更新标题
  },
  watch: {
    // '$route'() {
    //   this.updateTitle(); // 监听路由变化，更新标题
    // }
  },
  methods: {
    // updateTitle() {
    //   const pageTitle = '韶华杯官网'; // 固定部分的标题内容
    //   document.title = `${pageTitle}`;
    // }
  }
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

.el-carousel__arrow {
  width: 3vw !important;
  height: 3vw  !important;
  font-size: 35px !important;
}

/* 小屏幕/手机 */
@media screen and (max-width: 960px) {
  .el-carousel__arrow {
    width: 6vw !important;
    height: 6vw  !important;
    font-size: 14px !important;
  }
}
</style>
